import axios, { AxiosInstance } from "axios";
import { MondialRelaySearchedAddressLocation } from "@Types/addresses";
import { KonnektorApiMondialRelayLocation } from "@Types/api/addresses";

export default class KonnektorApiProvider {
  api: AxiosInstance;

  constructor(csrfToken: string) {
    const headers = {
      Accept: "application/json",
      "X-CSRF-TOKEN": csrfToken,
    };

    this.api = axios.create({
      baseURL: "https://mrapi.cheerz.com/api",
      headers,
    });
  }

  async getMondialRelayLocations(
    location: MondialRelaySearchedAddressLocation
  ): Promise<KonnektorApiMondialRelayLocation[]> {
    const { alpha2Code } = location;
    const { lat, lng } = location.position;

    if (lat && lng && alpha2Code) {
      const { data } = await this.api.get<KonnektorApiMondialRelayLocation[]>(
        `/shipping/mondial_relay?lat=${lat}&long=${lng}&country_tag=${alpha2Code}`
      );

      return data;
    } else return [];
  }
}
